import BaseService from "../../base/base_service";
import IGamblingSessionService from "./gambling_session_service_interface";

interface GamblingSessionServiceParams {
    enabled: boolean;
}
export default class GamblingSessionService extends BaseService implements IGamblingSessionService {
    static CLASS = 'GamblingSessionService'

    private _initParams: GamblingSessionServiceParams;
    init(params: GamblingSessionServiceParams) {
        super.init(params);
        this._initParams = params;

    }

    get isEnabled(): boolean {
        return this._initParams.enabled;
    }
}